// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3UrI8","alertIcon":"ConfirmModal_alertIcon__1CN7J"};